import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "@/i18n/translations";

const LANGUAGES = [
  { code: "es", label: "Espanol", flag: "ES" },
  { code: "en", label: "English", flag: "EN" },
  { code: "pt", label: "Portugues", flag: "PT" },
  { code: "fr", label: "Francais", flag: "FR" },
];

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("pv_lang") || "es");

  const changeLang = useCallback((code) => {
    setLang(code);
    localStorage.setItem("pv_lang", code);
  }, []);

  const t = useCallback((key) => {
    return translations[lang]?.[key] || translations["es"]?.[key] || key;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, changeLang, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useTranslation() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useTranslation must be used within LanguageProvider");
  return ctx;
}
